import { Modal } from 'components/Modals';
import React, { useState } from 'react';
import {
  ModalContainer,
  ModalContainerActionBox,
  ModalContainerHeader,
  ModalContainerHeaderTitle,
  ModalContainerText,
} from './styles';
import Button from 'components/Button';
import MessageModal from 'common/MessageModal';
import { useLoading } from 'hooks/useLoading';
import EventService from 'services/EventService';
import BusinessService from 'services/TouristOffersBusinessService';
import { BusinessStatusAPI, IBusiness } from 'interfaces/IBusinesses';
import IEvent, { EventStatusAPI } from 'interfaces/IEvent';

interface RemoveSolicitationModalProps {
  isOpen: boolean;
  toggle: () => void;
  item: IBusiness | IEvent;
}

const RemoveSolicitationModal = ({ isOpen, toggle, item }: RemoveSolicitationModalProps): JSX.Element => {
  const { openLoading, closeLoading } = useLoading();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const service = {
    event: new EventService(),
    business: new BusinessService(),
  };

  const sendRemoveSolicitation = async () => {
    openLoading();
    try {
      openLoading();
      if ('type' in item) {
        await service.business.delete(item.id);
      } else {
        await service.event.delete(item.id);
      }

      setShowSuccessModal(true);
    } catch (error) {
      setShowErrorModal(true);
    }
    closeLoading();
  };

  const closeModal = () => {
    setShowSuccessModal(false);
    setShowErrorModal(false);
    toggle();
  };

  return (
    <>
      <MessageModal
        isOpen={showSuccessModal}
        title="Sucesso"
        message="Oferta turística removida com sucesso!"
        onClose={closeModal}
      />
      <MessageModal
        isOpen={showErrorModal}
        title="Erro"
        message="Erro ao remover oferta turística!"
        onClose={closeModal}
      />
      {!(showSuccessModal || showErrorModal) && (
        <Modal isOpen={isOpen} toggle={toggle}>
          <ModalContainer>
            <ModalContainerHeader>
              <ModalContainerHeaderTitle>Remover a Oferta Turística</ModalContainerHeaderTitle>
            </ModalContainerHeader>
            <ModalContainerText>
              Você tem certeza de que deseja <b>remover</b> essa oferta turística? Se continuar com a ação, {''}
              <b>não será possível desfazê-la</b>.
            </ModalContainerText>
            <ModalContainerActionBox>
              <Button buttonType="outline" className="cancel-button" onClick={toggle}>
                Cancelar
              </Button>
              <Button type="submit" disabled={false} onClick={sendRemoveSolicitation}>
                Remover
              </Button>
            </ModalContainerActionBox>
          </ModalContainer>
        </Modal>
      )}
    </>
  );
};

export default RemoveSolicitationModal;
